import { defineComponent as _defineComponent } from 'vue'
import { t } from '@/plugins/i18n';
import { computed, onMounted, ref, watch } from 'vue';
import { useAppStore, useFloorplansStore, useFloorsStore, useLocationsStore } from '@/stores'
import PreviewImage from '../../components/PreviewImage.vue';
import CameraStates from '../../components/CameraStates.vue';
import {
  ApiCameraIncludes,
  ApiCameraWithIncludes,
  FloorResponse
} from '@eencloud/eewc-components/src/service/api-types';
import { getCamerasPositionsInFloor, isCameraInsideFloorplan } from '@/service/FloorplanFormulas'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCamerasSidebar',
  props: {
    open: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  open: boolean
};

const sidebarSize = ref(0);
const search = ref('')
const appStore = useAppStore();
const floorsStore = useFloorsStore();
const floorPlansStore = useFloorplansStore();
const locationsStore = useLocationsStore();
const availableCameras = ref<ApiCameraWithIncludes[]>([]);




onMounted(() =>  {
  onResize();
})

watch(
  () => [props.open, floorPlansStore.loadingFloorplans, locationsStore.currentLocationCameras],
  () => {
    if (floorsStore.currentFloor && !floorPlansStore.loadingFloorplans) {
      availableCameras.value = getAvailableCameras(floorsStore.currentFloor)
    }
  }
)
const getAvailableCameras = (currentFloor: FloorResponse) => {
  const currentLocationCameras = locationsStore.currentLocationCameras;
  if (!currentLocationCameras?.length || !currentFloor) {
    return []
  }

  const camerasWithPositionsRelatedToCurrentFloor = getCamerasPositionsInFloor(
    currentFloor,
    currentLocationCameras,
    floorPlansStore.currentFloorImage
  )

  return camerasWithPositionsRelatedToCurrentFloor.filter((camera) => {
    const cameraFloor = camera.devicePosition?.floor;
    const isTheSameFloorLevel = cameraFloor === currentFloor?.floorLevel;

    return !Number.isInteger(cameraFloor) || (!isCameraInsideFloorplan(camera) && isTheSameFloorLevel);
  })
}

const filteredCameras = computed(() => {
  if (!search.value) {
    return availableCameras.value
  } else {
    return availableCameras.value.filter((item) => {
      return search.value
          .toLowerCase()
          .split(' ')
          .every((v) => item.name.toLowerCase().includes(v))
    })
  }
})

function startDrag (evt: any, camera: ApiCameraIncludes) {
  const camera_string = JSON.stringify(camera)
  evt.dataTransfer.setData('camera', camera_string)
}

function onResize () {
  sidebarSize.value = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - 172;
}

return { __sfc: true,sidebarSize, search, appStore, floorsStore, floorPlansStore, locationsStore, availableCameras, props, getAvailableCameras, filteredCameras, startDrag, onResize, t, PreviewImage, CameraStates }
}

})